import React from "react";
// Material Imports
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
// Limitless Imports
import { useCustomerContext, useCustomerMessageContext } from "@limitless/customer/hooks";
import { SubmitButton } from "@limitless/customer/components";
import NewQuestionTextInput from "../new-question-text-input/NewQuestionTextInput";
import { useAppVisibilityContext } from "../../hooks/app-visibility/AppVisibilityContext";

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        marginTop: 24,
        marginLeft: 16,
        marginRight: 16
    },
    inputContainer: {
        marginBottom: 8
    }
});

const CreateNewMessageForm = () => {
    const { customer, getCustomerData, updateCustomer } = useCustomerContext();
    const { question, isFormInvalid, fieldErrors } = customer;
    const classes = useStyles();
    const { message, createMessage } = useCustomerMessageContext();
    const { toggleInputFocus } = useAppVisibilityContext();
    const history = useHistory();

    const handleFocus = () => {
        const isAndroidDevice = /(android)/i.test(navigator.userAgent);
        if (isAndroidDevice) {
            toggleInputFocus(true);
        }
    };

    const handleBlur = () => {
        toggleInputFocus(false);
    };

    const handleSubmit = () => {
        createMessage(getCustomerData(), newMessage => {
            history.push(`/conversation/${newMessage.messageId}/${newMessage.accessKey}/${false}`);
        });
    };

    const handleQuestionChange = event => {
        updateCustomer("question", event.target.value);
    };

    return (
        <div className={classes.container}>
            <NewQuestionTextInput
                label="Question"
                error={fieldErrors.question ? true : false}
                helperText={fieldErrors.question}
                onChange={handleQuestionChange}
                value={question.value}
                rows={4}
                multiline
                fullWidth
                containerClass={classes.inputContainer}
                onFocus={handleFocus}
                onBlur={handleBlur}
                disabled={message.loading}
            />

            <SubmitButton
                disabled={message.loading || isFormInvalid}
                title="Submit Your Question"
                handleSubmit={handleSubmit}
                loading={message.loading}
                containerEnabled={false}
            />
        </div>
    );
};

export default CreateNewMessageForm;
